import { render, staticRenderFns } from "./PassRecovery.vue?vue&type=template&id=438549ec&scoped=true"
import script from "./PassRecovery.vue?vue&type=script&lang=js"
export * from "./PassRecovery.vue?vue&type=script&lang=js"
import style0 from "./PassRecovery.vue?vue&type=style&index=0&id=438549ec&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "438549ec",
  null
  
)

export default component.exports